import React from 'react'
import {Time} from 'yougile-util'

import {DateTimeProps} from './types'
import {DivWithHint} from '@components/common/hint/hint'

export const DateTime = ({
  timestamp,
  type = 'datetime',
  className,
  skipCurrentDate,
  alwaysWithYear,
  round,
  fullMonth,
  comma,
  delimiter,
  componentTag
}: DateTimeProps) => {
  const datetime = Time.formatDateTime(
    timestamp,
    alwaysWithYear,
    skipCurrentDate,
    round,
    fullMonth,
    comma
  )

  let content = ''
  switch (type) {
    case 'date':
      content = Time.formatDate(timestamp, {
        alwaysWithYear,
        fullMonth,
        delimiter
      })
      break
    case 'time':
      content = Time.formatShort(timestamp, round)
      break
    case 'datetime':
      content = datetime
      break
    default:
      throw new Error(`Unknown type: ${type}`)
  }

  return (
    <DivWithHint
      componentTag={componentTag}
      className={className}
      content={datetime}
    >
      {content}
    </DivWithHint>
  )
}
